import { render } from "./stockgoodslist.vue?vue&type=template&id=66e049a1"
import script from "./stockgoodslist.vue?vue&type=script&lang=js"
export * from "./stockgoodslist.vue?vue&type=script&lang=js"

import exportComponent from "D:\\work\\web\\sal_appgd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__